import '../../packs/custom_selectize';
import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="components--select-pills"
export default class extends Controller {
  static get targets() {
    return ['select', 'list', 'addButton', 'template'];
  }

  static get values() {
    return { inputName: String };
  }

  add(event) {
    event.preventDefault();

    const option = this.selectTarget.options[this.selectTarget.selectedIndex];
    if (!option || !option.value) return;

    const value = String(option.value).trim();
    const label = String(option.text || option.value).trim();

    if (!value || this.hasPill(value)) return;

    this.insertPill(value, label);

    this.selectTarget.value = '';
  }

  remove(event) {
    event.preventDefault();

    const pill = event.currentTarget.closest('.select-pills__pill');
    if (pill) pill.remove();
  }

  hasPill(value) {
    return Array.from(
      this.listTarget.querySelectorAll('.select-pills__pill')
    ).some((pill) => pill.dataset.value === value);
  }

  insertPill(value, label) {
    const fragment = this.templateTarget.content.cloneNode(true);

    const pill = fragment.querySelector('.select-pills__pill');
    pill.dataset.value = value;

    const labelNode = fragment.querySelector('[data-label]');
    if (!labelNode) return;

    labelNode.textContent = label;

    const input = fragment.querySelector('[data-input]');
    if (!input) return;

    input.name = this.inputNameValue;
    input.value = value;

    this.listTarget.appendChild(fragment);
  }
}
